import * as React from 'react';
import Text from 'design-system/Text';
import { useAppSelector } from 'store/hooks';
import { Tier } from 'features/premium/entities';
import { tierThemes } from 'features/premium/benefits';
import { selectUserTier } from 'features/premium/selectors/tier';
import { selectUserFxFee } from '../reducers/selectors';
import { formatFXConversion } from '../utils';
const FxFeeEstSubTitle = ({ fxConversion }) => {
    const fxFee = useAppSelector(selectUserFxFee);
    const userTier = useAppSelector(selectUserTier);
    const fxConversionString = `(${formatFXConversion(fxConversion)})`;
    return (<Text TextThin-14 Gray centered>
      Your {tierThemes[userTier].name} plan has a {fxFee}% fee added on top of the interbank rate.{' '}
      {fxConversionString
            ? `The current rate is ${fxConversionString} and this is estimated based on the latest data we’ve received.`
            : ''}
      {userTier !== Tier.ultimate ? ' Upgrade to higher plans to lower this.' : ''}
    </Text>);
};
export default FxFeeEstSubTitle;
